import type { AppState } from 'src/app/store'
import { UserAdminFilters, WithdrawalFilter } from 'src/core/models'

export const brokerageStateSelector = (state: AppState) => state.admin.brokerage
export const isCarCalculeType = (state: AppState) =>
  state.admin.massiveCalculation.calculeUrl?.endsWith('calculate_cars_co2/')
export const isPlaneCalculeType = (state: AppState) =>
  state.admin.massiveCalculation.calculeUrl?.endsWith('plane/public/')
export const isParcelCalculeType = (state: AppState) =>
  state.admin.massiveCalculation.calculeUrl?.endsWith(
    'domestic/delivery/massive'
  )
export const purchasePriceCurrency = (state: AppState) =>
  state.admin.brokerage.baseForm.purchasePriceCurrency
export const salePriceCurrency = (state: AppState) =>
  state.admin.brokerage.baseForm.salePriceCurrency
export const isPurchaseTab = (state: AppState) =>
  state.admin.brokerage.selectedTab == 'PURCHASE'
export const selectedBrokerageTab = (state: AppState) =>
  state.admin.brokerage.selectedTab
export const adminStaticsSelector = (state: AppState) =>
  state.admin.adminStatics
export const usersAdminSelector = (state: AppState) => state.admin.users
export const usersAdminFilterTextSelector = (state: AppState) =>
  state.admin.users.filterText
export const usersAdminFilterTypeSelector = (state: AppState) =>
  state.admin.users.filterTypeOption
export const usersAdminFilterStatusSelector = (state: AppState) =>
  state.admin.users.filterStatusOption
export const usersAdminFilterGroupSelector = (state: AppState) =>
  state.admin.users.filterGroupOption
export const validateUserSelector = (state: AppState) =>
  state.admin.users.validateUser
export const rejectUserSelector = (state: AppState) =>
  state.admin.users.rejectUser
export const validateEmailForStockSaleSelector = (state: AppState) =>
  state.users.validateEmailForStockSale
export const validateProjectIdForStockSaleSelector = (state: AppState) =>
  state.projects.validateProjectIdForStockSale
export const withdrawalsSelector = (state: AppState) => state.admin.withdrawals
export const validateWithdrawalSelector = (state: AppState) =>
  state.admin.withdrawals.validateWithdrawal
export const cancelWithdrawalSelector = (state: AppState) =>
  state.admin.withdrawals.cancelWithdrawal
export const createBrokerageOperationSelector = (state: AppState) =>
  state.projects.createBrokerageOperation

export const purchaseDocumentsSelector = (state: AppState) =>
  state.admin.documents
export const validateCancellationSelector = (state: AppState) =>
  state.admin.documents.validateCancellation
export const adminTransfersSelector = (state: AppState) => state.admin.transfer
export const validateAdminTransferSelector = (state: AppState) =>
  state.admin.transfer.validateTransfer
export const rejectAdminTransferSelector = (state: AppState) =>
  state.admin.transfer.rejectTransfer
export const suppliersAPICronState = (state: AppState) =>
  state.admin.suppliersAPICron

export const adminDepositsSelector = (state: AppState) => state.admin.deposits

export const userAdminListFilterSelector = (
  state: AppState
): UserAdminFilters => {
  const filters = state.admin.users
  return {
    text: filters.filterText,
    user_type: filters.filterTypeOption,
    group: filters.filterGroupOption,
    status: filters.filterStatusOption
  }
}

export const withdrawalFilterSelector = (state: AppState): WithdrawalFilter => {
  const filters = state.admin.withdrawals
  return { status: filters.filterStatus, text: filters.filterText }
}
